import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Configuracao/Sidebar';
import VendasMes from '../components/Configuracao/VendasMes';
import SelecaoAnoMes from '../components/Configuracao/SelecaoAnoMes';
import ListaCorretores from '../components/Configuracao/ListaCorretores';
import Configuracoes from '../components/Configuracao/Configuracoes';
import Relatorio from './Relatorio';
import ComparativoVendas from './ComparativoVendas';
import Apresentacao from './Apresentacao';

function Configuracao() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Map routes to menu names
  const getMenuFromPath = (pathname) => {
    if (pathname === '/vendas') return 'Vendas';
    if (pathname === '/corretores') return 'Lista de Corretores';
    if (pathname === '/relatorio') return 'Relatório';
    if (pathname === '/comparativo') return 'Comparativo';
    if (pathname === '/apresentacao') return 'Apresentação';
    if (pathname === '/configuracoes') return 'Configurações';
    // Default to 'Lista de Corretores' if no specific route
    return 'Lista de Corretores';
  };
  
  // Restore last selected menu from localStorage or default to 'Lista de Corretores'
  const getInitialMenu = () => {
    // First, try to get menu from current path
    const menuFromPath = getMenuFromPath(location.pathname);
    if (menuFromPath !== 'Lista de Corretores') {
      return menuFromPath;
    }
    // Fallback to saved menu
    const savedMenu = localStorage.getItem('lastSelectedMenu');
    if (savedMenu) {
      return savedMenu;
    }
    // Default to 'Lista de Corretores'
    return 'Lista de Corretores';
  };
  
  const getInitialAno = () => {
    const savedAno = localStorage.getItem('lastSelectedAno');
    if (savedAno) {
      return parseInt(savedAno);
    }
    // If menu starts with VGV, try to extract year from menu name
    const savedMenu = localStorage.getItem('lastSelectedMenu');
    if (savedMenu && savedMenu.startsWith('VGV')) {
      const anoMatch = savedMenu.match(/VGV (\d+)/);
      if (anoMatch) {
        return parseInt(anoMatch[1]);
      }
    }
    return null;
  };
  
  const [menuSelecionado, setMenuSelecionado] = useState(getInitialMenu);
  const [anoSelecionado, setAnoSelecionado] = useState(getInitialAno);
  
  // Redirect unknown routes to /corretores
  useEffect(() => {
    const validRoutes = ['/vendas', '/corretores', '/relatorio', '/comparativo', '/apresentacao', '/configuracoes'];
    if (!validRoutes.includes(location.pathname)) {
      navigate('/corretores', { replace: true });
    }
  }, [location.pathname, navigate]);
  
  // Update menu when route changes
  useEffect(() => {
    const menuFromPath = getMenuFromPath(location.pathname);
    if (menuFromPath !== menuSelecionado) {
      setMenuSelecionado(menuFromPath);
    }
  }, [location.pathname]);
  
  // Save menu selection to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('lastSelectedMenu', menuSelecionado);
  }, [menuSelecionado]);
  
  // Save ano selection to localStorage whenever it changes
  useEffect(() => {
    if (anoSelecionado) {
      localStorage.setItem('lastSelectedAno', anoSelecionado.toString());
    }
  }, [anoSelecionado]);

  const handleSelecionarAno = (ano) => {
    setAnoSelecionado(ano);
    const newMenu = `VGV ${ano}`;
    setMenuSelecionado(newMenu);
    localStorage.setItem('lastSelectedMenu', newMenu);
  };

  const handleMenuClick = (menu) => {
    if (menu === 'Início') {
      navigate('/');
      return;
    }
    if (menu === 'Vendas') {
      // Reset selection when clicking Vendas again
      setAnoSelecionado(null);
      localStorage.removeItem('lastSelectedAno');
      navigate('/vendas');
      return;
    }
    // Navigation is handled by Sidebar, just update state
    setMenuSelecionado(menu);
    localStorage.setItem('lastSelectedMenu', menu);
  };

  const renderizarConteudo = () => {
    if (menuSelecionado === 'Lista de Corretores') {
      return <ListaCorretores />;
    }
    
    if (menuSelecionado === 'Relatório') {
      return <Relatorio />;
    }
    
    if (menuSelecionado === 'Comparativo') {
      return <ComparativoVendas />;
    }
    
    if (menuSelecionado === 'Apresentação') {
      return <Apresentacao />;
    }
    
    if (menuSelecionado === 'Configurações') {
      return <Configuracoes />;
    }
    
    if (menuSelecionado === 'Vendas') {
      return <SelecaoAnoMes onSelecionar={handleSelecionarAno} />;
    }
    
    // Se já tem ano selecionado e o menu começa com VGV, mostrar VendasMes
    if (anoSelecionado && menuSelecionado.startsWith('VGV')) {
      return <VendasMes ano={anoSelecionado} />;
    }
    
    // Fallback: mostrar seleção
    return <SelecaoAnoMes onSelecionar={handleSelecionarAno} />;
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar 
        onSelectMenu={handleMenuClick}
        menuSelecionado={menuSelecionado}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          ml: '0px',
        }}
      >
        {renderizarConteudo()}
      </Box>
    </Box>
  );
}

export default Configuracao;

